var $a9056b50f6fbb1ef$exports = {};
$a9056b50f6fbb1ef$exports = {
    "dismiss": `\u{BB34}\u{C2DC}`
};


export {$a9056b50f6fbb1ef$exports as default};
//# sourceMappingURL=ko-KR.mjs.map
